/**
 * ============================================================================
 * TRANSIENT: Appointment Config Page (appointment-config-page)
 * Type: poc
 * Amplitude key: none
 * End date: 2026-12-31
 * PR: #TODO_AFTER_PR_CREATION_appointment-config-page
 * ============================================================================
 */

import { Select } from '@evaneos/b2b-ui';

import { generateTimeOptions } from '../../../resources/appointment/operations';

const MAX_MINUTES = 23 * 60 + 45;

type Props = {
    value: string | undefined;
    onChange: (value: string) => void;
    minMinutes?: number;
    hasError?: boolean;
    'data-spec-id'?: string;
};

export const AppointmentTimeSelect = ({
    value,
    onChange,
    minMinutes = 0,
    hasError = false,
    'data-spec-id': dataSpecId,
}: Props): JSX.Element => {
    const options = generateTimeOptions(minMinutes, MAX_MINUTES);

    return (
        <Select
            native
            value={value ?? ''}
            size="small"
            onChange={(e) => {
                const val = e.target.value as string;
                if (val) onChange(val);
            }}
            inputProps={{ 'data-spec-id': dataSpecId } as object}
            sx={{
                minWidth: 90,
                ...(hasError && {
                    '& .MuiOutlinedInput-notchedOutline': { borderColor: 'error.main' },
                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'error.main' },
                }),
            }}
        >
            {value === undefined && (
                <option value="" disabled>
                    --:--
                </option>
            )}
            {options.map((opt) => (
                <option key={opt.value} value={opt.value}>
                    {opt.label}
                </option>
            ))}
        </Select>
    );
};
